module.exports = __webpack_public_path__ + "static/media/Forever - Instrumental Version.e8210acb.jpg";